import { Injectable } from '@angular/core';
import { Actions, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { take } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ActionListenerService {
  constructor(private updates$: Actions) {}

  listenForAction(action: Action, callback: (res: any) => void): void {
    this.updates$.pipe(ofType(action.type), take(1)).subscribe((res) => {
      callback(res);
    });
  }
}
